import { useState } from 'react'
import AdminNavigationLayout from 'shared/Layouts/TopNavigationLayout/AdminNavifationLayout'
import TopNavigationLayoutPageContent from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
import Button from 'shared/Buttons/Button/Button'
import useHttpLoader from 'shared/hooks/useHttpLoader'
import { useSetRecoilState } from 'recoil'
import { useNavigate } from 'react-router-dom'
import projectRolesTableAtom from '../../components/ProjectRolesTable/projectRolesTable.atom'
import projectRolesApi from '../../projectRoles.api'
import ProjectRoleSheet from '../../components/ProjectRoleSheet'


const CreateProjectRolePage = () => {
  const navigate = useNavigate()
  const { wait, loading } = useHttpLoader()
  const [draft, setDraft] = useState({ title: '', description: '' })
  const setState = useSetRecoilState(projectRolesTableAtom)

  const handleChange = (val: any, name: string) => {
    setDraft((prev) => ({ ...prev, [name]: val }))
  }

  const handleSave = () => {
    wait(projectRolesApi.create(draft), (resp) => {
      if (resp.status === 'success') {
        setState((prev) => ({ ...prev, items: [resp.body, ...prev.items] }))
        navigate('/admin/project-roles')
      }
    })
  }

  return (
    <AdminNavigationLayout>
      <TopNavigationLayoutPageContent type='default'>
        <div className='flex-space-between'>
          <div className='inline-flex-gap' style={{ gap: '2.5em' }}>
            <h2 className='page--header'>Создание роли в команде</h2>
          </div>
        </div>
        <ProjectRoleSheet projectRole={draft} onChange={handleChange}>
          <Button theme='primary' loading={loading} onClick={handleSave} style={{ width: 'fit-content' }}>
            Создать
          </Button>
        </ProjectRoleSheet>
      </TopNavigationLayoutPageContent>
    </AdminNavigationLayout>
  )
}

export default CreateProjectRolePage
